import { Builder } from '@builder.io/react'
import { useState } from 'react'

type BookmarkScrollerProps = {
  behavior: ScrollBehavior;
}

const BookmarkScroller = ( props: BookmarkScrollerProps ) => {
  const [ isScrolled, setIsScrolled ] = useState( false )
  const scrollOptions: ScrollIntoViewOptions = {
    behavior: props.behavior
  }

  if ( Builder.isBrowser ) {
    window.addEventListener( `load`, () => {
      const {hash} = window.location

      if ( hash && !isScrolled ) {
        const el = document.querySelector( hash )
        if ( el ) {
          el.scrollIntoView( scrollOptions )
          setIsScrolled( true )
        }
      }
    })
  }

  return null
}

Builder.registerComponent( BookmarkScroller, {
  name: `BookmarkScroller`,
  inputs: [
    {
      name: `behavior`,
      type: `string`,
      enum: [ `auto`, `smooth` ],
      defaultValue: `smooth`
    }
  ]
})

export default BookmarkScroller